export default __webpack_public_path__ + "static/media/multiusers.c1a4bdf5.svg";